<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ data.trolley_code }} Trolley</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            :aria-label="$t(`addNewContactsModal.close`)"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row px-1 text-center">
            <div class="col-2"></div>
            <div class="col-3 bold-12 text-gray">Pack code</div>
            <div class="col-3 bold-12 text-gray">Size</div>
            <div class="col-2 bold-12 text-gray">Maximum sales</div>
          </div>
          <draggable
            :list="data.trolleyPacks"
            item-key="id"
            v-bind="dragOptions"
            v-on:end="moveEvent"
          >
            <template #item="{ element, index }">
              <div class="row align-items-center text-center drag-row">
                <div class="col-2 text-center">
                  <BaseIcon name="order" class="drag-handle" />
                </div>
                <div class="col-3 bold-16">{{ element.pack_code }}</div>
                <div class="col-3">
                  <span class="badge badge-outline">{{ element.name }}</span>
                </div>
                <div class="col-2">{{ element.order_limit ?? "—" }}</div>
                <div class="col-2 text-center">
                  <button
                    class="btn btn-sm btn-outline-danger"
                    v-on:click="deleteRow(element.id, index)"
                  >
                    <BaseIcon name="trash" />
                  </button>
                </div>
              </div>
            </template>
          </draggable>
          <h4 class="mt-4 bold-19">Add new</h4>
          <div class="row mt-2 align-items-end custom-input">
            <div class="col-3 whitebg-input">
              <label class="form-label bold-12 text-gray">Pack code</label>
              <input
                type="text"
                class="form-control"
                v-model="newRow.pack_code"
              />
            </div>
            <div class="col-3 whitebg-input">
              <label class="form-label bold-12 text-gray">Size</label>
              <select
                class="form-control"
                v-model="newRow.trolley_pack_size_id"
              >
                <option v-for="size in sizes" :key="size.id" :value="size.id">
                  {{ size.name }}
                </option>
              </select>
            </div>
            <div class="col-3 whitebg-input">
              <label class="form-label bold-12 text-gray">
                Maximum sales
              </label>
              <input
                type="text"
                class="form-control"
                v-model="newRow.order_limit"
              />
            </div>
            <div class="col-3 text-end">
              <button
                type="button"
                class="btn btn-primary"
                v-on:click="addAsset"
                :class="{ 'loading-spin': loadAddBtn }"
                :disabled="loadAddBtn"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../modules/http";
import BaseIcon from "../icons/BaseIcon.vue";
import draggable from "vuedraggable";
const bootstrap = require("bootstrap");

export default {
  name: "TrolleyBox",
  props: {
    modelValue: Object,
    sizes: Array,
  },
  emits: ["update:modelValue", "add"],
  data() {
    return {
      myModal: undefined,
      success: false,
      loadAddBtn: false,
      data: [],
      newRow: {},
      dragOptions: {
        animation: 200,
        ghostClass: "ghost",
      },
    };
  },
  watch: {
    modelValue() {
      if (this.modelValue > 0) {
        this.load();
      }
    },
  },
  methods: {
    showModal() {
      if (this.myModal === undefined) {
        this.myModal = new bootstrap.Modal(this.$refs.modal, {
          backdrop: "static",
        });
      }
      this.myModal.show();
    },
    load() {
      http.fetch("/trolleys/" + this.modelValue).then((data) => {
        data.trolleyPacks.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
        this.data = data;
        this.newRow.pack_code = data.trolleyPacks.length + 1;
      });
    },
    deleteRow(id, i) {
      http.fetch("/trolleys/pack/" + id, {}, true, "DELETE");
      this.data.trolleyPacks.splice(i, 1);
    },
    moveEvent() {
      http.fetch(
        `/trolleys/${this.modelValue}/packs/order`,
        {
          trolley_id: this.modelValue,
          packs: this.data.trolleyPacks.map((pack) => pack.id),
        },
        true
      );
    },
    addAsset() {
      this.loadAddBtn = true;
      this.newRow.trolley_id = this.modelValue;
      http
        .fetch("/trolleys/pack/add", this.newRow, true)
        .then((data) => {
          data.name = this.sizes.find(
            (e) => e.id == this.newRow.trolley_pack_size_id
          )?.name;
          this.data.trolleyPacks.push(data);
          this.loadAddBtn = false;
          this.newRow.pack_code += 1;
        })
        .catch(() => {
          this.loadAddBtn = false;
        });
    },
  },
  components: { BaseIcon, draggable },
};
</script>
<style scoped>
.drag-handle {
  cursor: grab;
}
.drag-handle :deep(svg) {
  width: 18px;
  height: 18px;
}
.drag-row {
  background-color: var(--extra-light);
  border: 1px solid var(--gray-lightest);
  border-radius: 8px;
  padding-block: 8px;
  margin-bottom: 8px;
}
.drag-row.ghost {
  opacity: 0.5;
}
</style>
